import {forEach} from 'lodash'

const SELECTORS = {
  LOADER: '#Loader',
}

const $bases = $('html, body')
const $loader = $(SELECTORS.LOADER)

const CLASS_LOADER_VISIBLE = 'loader--is-visible'

let TIMEOUTS = []

export default { init, teardown }

function init() {
  $bases.addClass('not-scrollable')
  $loader.addClass(CLASS_LOADER_VISIBLE)
  const timeout1 = setTimeout(teardown, 2000)
  TIMEOUTS.push(timeout1)
}

function teardown() {
  forEach(TIMEOUTS, (item) => clearTimeout(item))
  $bases.removeClass('not-scrollable')
  $loader.removeClass(CLASS_LOADER_VISIBLE).one('transitionend', (event) => $loader.remove())
  sessionStorage.setItem('loader-has-loaded', 'true')
}



// WEBPACK FOOTER //
// ./loader.js